import { useEffect } from 'react';
import useAuthStore from '../stores/authStore';
import { hideRecaptchaBadge, showRecaptchaBadge } from '../utils/recaptcha';

/**
 * Hook to automatically manage reCAPTCHA badge visibility based on authentication status
 * Hides the badge when user is logged in, shows it when needed for authentication
 */
export const useRecaptchaBadgeManager = () => {
  const { accessToken } = useAuthStore();

  useEffect(() => {
    if (accessToken) {
      // User is logged in - hide the badge since most protected endpoints
      // are for user management and don't need visible reCAPTCHA feedback
      hideRecaptchaBadge();
    } else {
      // User is not logged in - badge may be needed for login/signup
      // But still hide by default and show only during actual reCAPTCHA operations
      hideRecaptchaBadge();
    }
  }, [accessToken]);
};

export default useRecaptchaBadgeManager;
